<template>
    <v-container max-width="1500" style="max-width: 1500px !important">
        <v-card class="mx-auto my-5 elevation-1" style="margin-bottom: 2rem !important;">
            <v-row class="fill-height">
                <v-col>
                    <v-sheet height="64">
                        <v-toolbar flat>
                            <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
                                Hoy
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="prev">
                                <v-icon small>mdi-chevron-left</v-icon>
                            </v-btn>
                            <v-btn fab text small color="grey darken-2" @click="next">
                                <v-icon small>mdi-chevron-right</v-icon>
                            </v-btn>
                            <v-toolbar-title v-if="$refs.calendar">
                                {{ $refs.calendar.title.charAt(0).toUpperCase() +
                                    $refs.calendar.title.slice(1).toLowerCase() }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="dialog = true" style="margin: 1rem !important;">
                                Enviar Solicitud
                            </v-btn>
                            <v-menu bottom right>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                                        <span>{{ typeToLabel[type] }}</span>
                                        <v-icon right>mdi-menu-down</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        @click="type = 'day'"><v-list-item-title>Día</v-list-item-title></v-list-item>
                                    <v-list-item
                                        @click="type = 'week'"><v-list-item-title>Semana</v-list-item-title></v-list-item>
                                    <v-list-item
                                        @click="type = 'month'"><v-list-item-title>Mes</v-list-item-title></v-list-item>
                                    <v-list-item @click="type = '4day'"><v-list-item-title>4
                                            Días</v-list-item-title></v-list-item>
                                </v-list>
                            </v-menu>
                        </v-toolbar>
                    </v-sheet>
                    <v-sheet height="700">
                        <v-calendar ref="calendar" v-model="focus" color="primary" :events="formattedEvents"
                            :event-color="getEventColor" :type="type" @click:event="showEvent" @click:more="viewDay"
                            @click:date="viewDay">
                            <template v-slot:event="event">
                                <div style="display: flex; align-items: center;">
                                    <span style="margin: 0 .5rem;">
                                        {{ event.event.name }}
                                    </span>
                                    <div class="icon-ordinario" v-if="event.event.importancia == 'Ordinaria'"></div>
                                    <div class="icon-importante" v-if="event.event.importancia == 'Importante'"></div>
                                    <div class="icon-muy-importante" v-if="event.event.importancia == 'Muy Importante'">
                                    </div>
                                </div>
                            </template>
                        </v-calendar>
                        <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement"
                            offset-x>
                            <v-card color="grey lighten-4" min-width="350px" max-width="600px" flat shaped>
                                <v-toolbar :color="selectedEvent.color" dark>
                                    <v-tooltip top color="info">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click="openEdit(selectedEvent, selectedEvent.id)"
                                                v-bind="attrs" v-on="on">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>
                                    <v-toolbar-title v-html="selectedEvent.name_title"></v-toolbar-title>
                                    <v-spacer></v-spacer>
                                    <v-tooltip top color="info">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon @click="selectedOpen = false" v-bind="attrs" v-on="on">
                                                <v-icon>mdi mdi-close-box</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Cerrar</span>
                                    </v-tooltip>
                                </v-toolbar>
                                <v-card-text>
                                    <div style="margin: .5rem 0;" v-if="selectedEvent.details !== ''">
                                        <v-icon style="margin-right: 1rem !important;">mdi-text-account</v-icon><span
                                            style="margin-right: 1rem !important;"
                                            v-html="selectedEvent.details"></span>
                                    </div>
                                    <div style="margin: .5rem 0;" v-if="selectedEvent.participantes_id !== ''">
                                        <v-icon
                                            style="margin-right: 1rem !important;">mdi-account-supervisor</v-icon><span
                                            style="margin-right: 1rem !important;"
                                            v-html="formatParticipantes(selectedEvent.participantes_id)"></span>
                                    </div>
                                    <div style="margin: .5rem 0;" v-if="selectedEvent.area_nombre !== ''">
                                        <v-icon style="margin-right: 1rem !important;">mdi
                                            mdi-home-account</v-icon><span style="margin-right: 1rem !important;"
                                            v-html="selectedEvent.area_nombre"></span>
                                    </div>
                                    <div style="margin: .5rem 0;" v-if="selectedEvent.hora_inicio_text !== ''">
                                        <v-icon
                                            style="margin-right: 1rem !important;">mdi-clock-time-five-outline</v-icon>
                                        <span v-html="selectedEvent.hora_inicio_text"></span> - <span
                                            v-html="selectedEvent.hora_fin_text"></span>
                                    </div>
                                    <div style="margin: .5rem 0;" v-if="selectedEvent.sala !== ''">
                                        <v-icon style="margin-right: 1rem !important;">mdi mdi-store</v-icon>
                                        <span v-html="selectedEvent.sala"></span>
                                    </div>
                                </v-card-text>
                                <v-card-actions>
                                    <!-- <v-tooltip bottom color="success" v-if="selectedEvent.color == '#f6bf26'">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on"
                                                style="margin-right: 1rem !important;color: #33b679;cursor: pointer;"
                                                @click="confirmarReunion(selectedEvent, selectedEvent.id)">
                                                mdi mdi-check-circle
                                            </v-icon>
                                        </template>
                                        <span>Aceptar</span>
                                    </v-tooltip> -->
                                    <v-tooltip bottom color="error">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on"
                                                style="margin-right: 1rem !important;color: #d50000;cursor: pointer;"
                                                @click="rechazarReunion(selectedEvent, selectedEvent.id)">
                                                mdi mdi-alpha-x-circle
                                            </v-icon>
                                        </template>
                                        <span>Rechazar</span>
                                    </v-tooltip>
                                </v-card-actions>
                            </v-card>
                        </v-menu>
                    </v-sheet>
                </v-col>
            </v-row>
        </v-card>

        <!-- Dialog para formulario de nueva reunión -->
        <v-dialog v-model="dialog" max-width="800px">
            <v-card>
                <v-card-title class="headline">{{ this.title }} Reunión</v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valid">
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="newEvent.title" label="Título" required dense
                                    outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="newEvent.date" label="Fecha" type="date" required dense
                                    outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="newEvent.startTime" label="Hora de inicio" type="time" required
                                    dense outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <v-text-field v-model="newEvent.endTime" label="Hora de finalización" type="time"
                                    required dense outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="newEvent.participantes_id" label="Participantes"
                                    :items="arrayAreas" required dense item-text="nombre" item-value="id" outlined
                                    multiple>
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                        <!-- <v-row>
                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="newEvent.area" label="Área" :items="arrayAreas" required dense
                                    item-text="nombre" item-value="id" outlined>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="newEvent.participantes" label="Participantes" required dense
                                    outlined></v-text-field>
                            </v-col>
                        </v-row> -->
                        <!-- <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="newEvent.correo_sol" label="Correo Solicitante" required dense
                                    outlined></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field v-model="newEvent.correo_jef" label="Correo Jefatura" required dense
                                    outlined></v-text-field>
                            </v-col>
                        </v-row> -->
                        <v-row>
                            <v-col cols="4">
                                <v-select v-model="newEvent.importancia" label="Importancia" :items="arrayImportancia"
                                    item-text="tipo" item-value="tipo" outlined dense ref="selectEncImpor">
                                    <!-- Personaliza la opción con un círculo de color -->
                                    <template v-slot:item="{ item }">
                                        <v-list-item class="hover-style" @click="seleccionarImportancia(item)">
                                            <v-list-item-avatar>
                                                <span class="color-circle"
                                                    :style="{ backgroundColor: item.codigo }"></span>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ item.tipo }}</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    <!-- Muestra la opción seleccionada con su color -->
                                    <template v-slot:selection="{ item }">
                                        <v-chip
                                            :style="{ backgroundColor: item.codigo, color: 'white', height: '.8rem' }">
                                        </v-chip>{{ item.tipo }}
                                    </template>

                                </v-select>
                            </v-col>
                            <v-col cols="4">
                                <v-select v-model="newEvent.sala" label="Sala" :items="['Todo', 'Lado A', 'Lado B']"
                                    outlined dense>
                                </v-select>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea v-model="newEvent.description" label="Descripción" dense
                                    outlined rows="5"  style="height: 150px;max-height: 150px;"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" @click="saveEvent" v-if="!statusEdit">{{ this.titleButton }}</v-btn>
                    <v-btn color="primary" @click="updateEvent" v-if="statusEdit">{{ this.titleButton }}</v-btn>
                    <v-btn color="secondary" text @click="closeEdit">Cancelar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogLoader" persistent width="300"
            style="padding: 1rem;overflow: hidden !important;background: white !important;">
            <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
        </v-dialog>
    </v-container>
</template>

<script>
import Swal from "sweetalert2";
import { Chrome } from 'vue-color';
import axios from "axios";
import { height } from "@fortawesome/free-brands-svg-icons/fa42Group";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
    data: () => ({
        arrayAreas: [],
        dialogLoader: false,
        campoRequerido: v => !!v || "Este campo es obligatorio",
        arrayColores: [
            { color: "Rojo", codigo: "#d50000" },
            { color: "Mandarina", codigo: "#f4511e" },
            { color: "Verde esmeralda", codigo: "#33b679" },
            { color: "Azul turquesa", codigo: "#039be5" },
            { color: "Lavanda", codigo: "#7986cb" },
            { color: "Rosa chicle", codigo: "#e67c73" },
            { color: "Amarillo", codigo: "#f6bf26" },
            { color: "Morado intenso", codigo: "#8e24aa" }
        ],
        arrayImportancia: [
            { tipo: "Ordinaria", codigo: "#33b679" },
            { tipo: "Importante", codigo: "#f6bf26" },
            { tipo: "Muy Importante", codigo: "#d50000" }
        ],
        statusEdit: false,
        title: 'Nueva',
        titleButton: 'Enviar',
        selectedColorImportancia: null,
        selectedColor: { hex: "#2196F3" },
        focus: '',
        type: 'month',
        typeToLabel: {
            month: 'Mes',
            week: 'Semana',
            day: 'Día',
            '4day': '4 Días',
        },
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        dialog: false,
        events: [],
        valid: false,
        eventId: null,
        newEvent: {
            title: '',
            description: '',
            date: '',
            startTime: '',
            endTime: '',
            area: '',
            participantes: [],
            color: '#039be5',
            importancia: '',
            sala: '',
            correo_sol: '',
            correo_jef: '',
            participantes_id: [],
            user_created:null
        },
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        arrayCorreos: [],
        idUsuario:null,
        correoAuditorioUsuario: null,
        usuarioArea:null
    }),
    computed: {
        formattedEvents() {
            return this.events.map(event => ({
                ...event,
                name: `${event.name} (${event.hora_inicio_text} - ${event.hora_fin_text})`,
                name_title: `${event.name}`
            }));
        },
    },
    mounted() {
        this.$refs.calendar.checkChange();
    },
    created() {
        this.loadEventos();
        this.loadCorreo();
        this.loadAreas();
        this.idUsuario = sessionStorage.getItem("idUsuario");
        this.correoAuditorioUsuario = sessionStorage.getItem("correoAuditorioUsuario");
        this.usuarioArea = sessionStorage.getItem("usuarioArea");
    },
    methods: {
        formatParticipantes(participantes) {
            if (!participantes || participantes.length === 0) return '';

            // Obtener los nombres correspondientes a los IDs
            let nombres = participantes
                .map(id => this.arrayAreas[id]?.nombre || '')
                .filter(nombre => nombre); // Filtra valores vacíos

            // Unir nombres por comas
            let resultado = nombres.join('; ');

            // Limitar a 20 caracteres
            return resultado;
        },
        loadAreas() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .get(RUTA_API + "/auditorio-areas/", {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayAreas = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        loadCorreo() {0
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_correo_auditorio/", {}, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayCorreos = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        enviarAlCorreo(evento) {
            for (let i = 0; i < this.arrayCorreos.length; i++) {
                let data = {
                    asunto: "NUEVA SOLICITUD REGISTRADA",
                    mensaje: "Notificación de nueva reunión",
                    destinatario: this.arrayCorreos[i].correo,
                    html: `<div style="width:700px;margin: 0 auto;">
                                <div style="width:700px;">
                                    <img src="https://inhouse.academicovitem.com/assets/img/logos/essalud-renal.png" width="200" >
                                </div>
                                <div >
                                    <h1 style="color:#007AC9;text-transform:uppercase;font-weight:600;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;text-align:center;">NUEVA SOLICITUD REGISTRADA</h1>
                                </div>
                                <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Este correo fue generado de forma automática por<strong style="color:#766AE0"> HISAR-SERVICE,</strong><strong style="color:#766AE0"> Por favor no responder.</strong></p>
                                <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Se notifica la creación de la siguiente reunión.</strong></p>
                                <div style="width:fit-content;margin:0 auto;margin-bottom:5px;border-radius:7px;padding:10px;background-color:#E3DDFB;">  
                                    <h3 style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Título:${evento.name}</h3>
                                    
                                    <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Descripción: ${evento.description ? evento.description : '-'}</p>
                                    <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Participantes: ${this.formatParticipantes(evento.participantes_id)}</p>
                                    <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Área: ${evento.area}</p>
                                    <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Hora: ${evento.startTime} - ${evento.endTime}</p>
                                </div>
                                <div style="background-color:#007AC9;color:#FFF;padding-top:2px">
                                    <p style="padding:5px;text-align:center;font-size:14px;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">@HISAR-SERVICE / DSI</p>
                                </div>  
                    </div>`,
                };
                axios
                    .post(RUTA_API + "/api/token/", {
                        username: USUARIO,
                        password: PASSWORD,
                    })
                    .then((response) => {
                        this.auth = "Bearer " + response.data.access;
                        axios
                            .post(RUTA_API + "/enviar-correo-adj/", data, {
                                headers: { Authorization: this.auth },
                            })
                            .then((res) => {

                            });
                    });
            }
            this.enviarAlCorreoSol(evento, evento.correo_sol);
        },
        enviarAlCorreoSol(evento, correo) {
            let data = {
                asunto: "SOLICITUD REGISTRADA",
                mensaje: "Solicitud registrada",
                destinatario: correo,
                html: `<div style="width:700px;margin: 0 auto;">
                    <div style="width:700px;">
                        <img src="https://inhouse.academicovitem.com/assets/img/logos/essalud-renal.png" width="200" >
                    </div>
                    <div >
                        <h1 style="color:#007AC9;text-transform:uppercase;font-weight:600;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;text-align:center;">SOLICITUD REGISTRADA</h1>
                    </div>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Este correo fue generado de forma automática por<strong style="color:#766AE0"> HISAR-SERVICE,</strong><strong style="color:#766AE0"> Por favor no responder.</strong></p>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Se notifica el registro correcto de la solicitud para la siguiente reunión.</strong></p>
                    <div style="width:fit-content;margin:0 auto;margin-bottom:5px;border-radius:7px;padding:10px;background-color:#E3DDFB;">  
                        <h3 style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Título:${evento.name}</h3>
                        
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Descripción: ${evento.description ? evento.description : '-'}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Luci da Sans', Arial, sans-serif;color:#000">Participantes: ${evento.participantes}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Área: ${evento.area}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Hora: ${evento.startTime} - ${evento.endTime}</p>
                    </div>
                    <div style="background-color:#007AC9;color:#FFF;padding-top:2px">
                        <p style="padding:5px;text-align:center;font-size:14px;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">@HISAR-SERVICE / DSI</p>
                    </div>  
        </div>`,
            };
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/enviar-correo-adj/", data, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.enviarAlCorreoJef(evento, evento.correo_jef);
                        });
                });

        },
        enviarAlCorreoJef(evento, correo) {
            let data = {
                asunto: "SOLICITUD REGISTRADA",
                mensaje: "Solicitud registrada",
                destinatario: correo,
                html: `<div style="width:700px;margin: 0 auto;">
                    <div style="width:700px;">
                        <img src="https://inhouse.academicovitem.com/assets/img/logos/essalud-renal.png" width="200" >
                    </div>
                    <div >
                        <h1 style="color:#007AC9;text-transform:uppercase;font-weight:600;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;text-align:center;">SOLICITUD REGISTRADA</h1>
                    </div>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Este correo fue generado de forma automática por<strong style="color:#766AE0"> HISAR-SERVICE,</strong><strong style="color:#766AE0"> Por favor no responder.</strong></p>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Se notifica el registro correcto de la solicitud para la siguiente reunión.</strong></p>
                    <div style="width:fit-content;margin:0 auto;margin-bottom:5px;border-radius:7px;padding:10px;background-color:#E3DDFB;">  
                        <h3 style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Título:${evento.name}</h3>
                        
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Descripción: ${evento.description ? evento.description : '-'}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Participantes: ${evento.participantes}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Área: ${evento.area}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Hora: ${evento.startTime} - ${evento.endTime}</p>
                    </div>
                    <div style="background-color:#007AC9;color:#FFF;padding-top:2px">
                        <p style="padding:5px;text-align:center;font-size:14px;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">@HISAR-SERVICE / DSI</p>
                    </div>  
        </div>`,
            };
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/enviar-correo-adj/", data, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "Se registró la solicitud correctamente",
                                icon: "success",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "Aceptar"
                            })
                            this.dialogLoader = false;
                        });
                });
        },
        correoConfirmacionSol(evento, correo) {
            let data = {
                asunto: "SOLICITUD APROBADA AUDITORIO",
                mensaje: "Solicitud aprobada auditorio",
                destinatario: correo,
                html: `<div style="width:700px;margin: 0 auto;">
                    <div style="width:700px;">
                        <img src="https://inhouse.academicovitem.com/assets/img/logos/essalud-renal.png" width="200" >
                    </div>
                    <div >
                        <h1 style="color:#007AC9;text-transform:uppercase;font-weight:600;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;text-align:center;">SOLICITUD APROBADA AUDITORIO</h1>
                    </div>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Este correo fue generado de forma automática por<strong style="color:#766AE0"> HISAR-SERVICE,</strong><strong style="color:#766AE0"> Por favor no responder.</strong></p>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">La solicitud a sido a probada de la siguiente reunión.</strong></p>
                    <div style="width:fit-content;margin:0 auto;margin-bottom:5px;border-radius:7px;padding:10px;background-color:#E3DDFB;">  
                        <h3 style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Título:${evento.title}</h3>
                        
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Descripción: ${evento.description ? evento.description : '-'}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Participantes: ${evento.participantes}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Área: ${evento.area}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Hora: ${evento.startTime} - ${evento.endTime}</p>
                    </div>
                    <div style="background-color:#007AC9;color:#FFF;padding-top:2px">
                        <p style="padding:5px;text-align:center;font-size:14px;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">@HISAR-SERVICE / DSI</p>
                    </div>  
        </div>`,
            };
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/enviar-correo-adj/", data, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.correoConfirmacionJef(evento, evento.correo_jef)
                            this.dialogLoader = false;
                        });
                });
        },
        correoConfirmacionJef(evento, correo) {
            let data = {
                asunto: "SOLICITUD APROBADA AUDITORIO",
                mensaje: "Solicitud aprobada auditorio",
                destinatario: correo,
                html: `<div style="width:700px;margin: 0 auto;">
                    <div style="width:700px;">
                        <img src="https://inhouse.academicovitem.com/assets/img/logos/essalud-renal.png" width="200" >
                    </div>
                    <div >
                        <h1 style="color:#007AC9;text-transform:uppercase;font-weight:600;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;text-align:center;">SOLICITUD APROBADA AUDITORIO</h1>
                    </div>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Este correo fue generado de forma automática por<strong style="color:#766AE0"> HISAR-SERVICE,</strong><strong style="color:#766AE0"> Por favor no responder.</strong></p>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">La solicitud a sido a probada de la siguiente reunión.</strong></p>
                    <div style="width:fit-content;margin:0 auto;margin-bottom:5px;border-radius:7px;padding:10px;background-color:#E3DDFB;">  
                        <h3 style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Título:${evento.title}</h3>
                        
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Descripción: ${evento.description ? evento.description : '-'}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Participantes: ${evento.participantes}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Área: ${evento.area}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Hora: ${evento.startTime} - ${evento.endTime}</p>
                    </div>
                    <div style="background-color:#007AC9;color:#FFF;padding-top:2px">
                        <p style="padding:5px;text-align:center;font-size:14px;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">@HISAR-SERVICE / DSI</p>
                    </div>  
        </div>`,
            };
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/enviar-correo-adj/", data, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            window.location.reload();
                            this.dialogLoader = false;
                        });
                });
        },
        confirmarReunion(item, id) {
            this.eventId = id;
            this.newEvent.title = item.name_title;
            this.newEvent.description = item.details;
            this.newEvent.date = item.date;
            this.newEvent.startTime = item.hora_inicio_text;
            this.newEvent.endTime = item.hora_fin_text;
            this.newEvent.area = item.area;
            this.newEvent.participantes = item.participantes;
            this.newEvent.color = item.color;
            this.newEvent.importancia = item.importancia;
            this.newEvent.sala = item.sala;
            this.newEvent.correo_sol = item.correo_sol;
            this.newEvent.correo_jef = item.correo_jef;
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de aceptar la reunión?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .post(RUTA_API + "/generar_actualizar_evento/", {
                                    id: this.eventId,
                                    titulo: this.newEvent.title,
                                    descripcion: this.newEvent.details,
                                    fecha: this.newEvent.date,
                                    hora_inicio: this.newEvent.start,
                                    hora_fin: this.newEvent.end,
                                    area: this.newEvent.area,
                                    creado_por: 'AUDITORIA',
                                    participantes: this.newEvent.participantes,
                                    estado: '1',
                                    color: '#33b679',
                                    hora_inicio_text: `${this.newEvent.startTime}`,
                                    hora_fin_text: `${this.newEvent.endTime}`,
                                    sala: this.newEvent.sala,
                                    importancia: this.newEvent.importancia,
                                    correo_sol: this.newEvent.correo_sol,
                                    correo_jef: this.newEvent.correo_jef
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        text: "La reunión se aceptó con exito.",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.eventId = null;
                                    this.loadEventos();
                                    this.correoConfirmacionSol(this.newEvent, this.newEvent.correo_sol)
                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });

                }
            });
        },
        notificarCorreoRechSol(evento, correo) {
            let data = {
                asunto: "SOLICITUD RECHAZADA",
                mensaje: "Solicitud rechazada",
                destinatario: correo,
                html: `<div style="width:700px;margin: 0 auto;">
                    <div style="width:700px;">
                        <img src="https://inhouse.academicovitem.com/assets/img/logos/essalud-renal.png" width="200" >
                    </div>
                    <div >
                        <h1 style="color:#007AC9;text-transform:uppercase;font-weight:600;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;text-align:center;">SOLICITUD RECHAZADA AUDITORIO</h1>
                    </div>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Este correo fue generado de forma automática por<strong style="color:#766AE0"> HISAR-SERVICE,</strong><strong style="color:#766AE0"> Por favor no responder.</strong></p>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">La solicitud de la siguiente reunión a sido rechazada.</strong></p>
                    <div style="width:fit-content;margin:0 auto;margin-bottom:5px;border-radius:7px;padding:10px;background-color:#E3DDFB;">  
                        <h3 style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Título:${evento.title}</h3>
                        
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Descripción: ${evento.description ? evento.description : '-'}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Participantes: ${this.formatParticipantes(evento.participantes_id)}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Área: ${evento.area}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Hora: ${evento.startTime} - ${evento.endTime}</p>
                    </div>
                    <div style="background-color:#007AC9;color:#FFF;padding-top:2px">
                        <p style="padding:5px;text-align:center;font-size:14px;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">@HISAR-SERVICE / DSI</p>
                    </div>  
        </div>`,
            };
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/enviar-correo-adj/", data, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                        title: "¡Exito!",
                                        text: "La reunión se eliminó con exito.",
                                        icon: "success",
                                        draggable: true
                                    });
                            this.dialogLoader = false;
                        });
                });
        },
        notificarCorreoRechSolJef(evento, correo) {
            let data = {
                asunto: "SOLICITUD RECHAZADA",
                mensaje: "Solicitud rechazada",
                destinatario: correo,
                html: `<div style="width:700px;margin: 0 auto;">
                    <div style="width:700px;">
                        <img src="https://inhouse.academicovitem.com/assets/img/logos/essalud-renal.png" width="200" >
                    </div>
                    <div >
                        <h1 style="color:#007AC9;text-transform:uppercase;font-weight:600;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;text-align:center;">SOLICITUD RECHAZADA AUDITORIO</h1>
                    </div>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Este correo fue generado de forma automática por<strong style="color:#766AE0"> HISAR-SERVICE,</strong><strong style="color:#766AE0"> Por favor no responder.</strong></p>
                    <p style="text-align:center;font-size:15px;;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">La solicitud de la siguiente reunión a sido rechazada.</strong></p>
                    <div style="width:fit-content;margin:0 auto;margin-bottom:5px;border-radius:7px;padding:10px;background-color:#E3DDFB;">  
                        <h3 style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;">Título:${evento.title}</h3>
                        
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Descripción: ${evento.description ? evento.description : '-'}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Participantes: ${evento.participantes}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Área: ${evento.area}</p>
                        <p style="text-align:center;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;color:#000">Hora: ${evento.startTime} - ${evento.endTime}</p>
                    </div>
                    <div style="background-color:#007AC9;color:#FFF;padding-top:2px">
                        <p style="padding:5px;text-align:center;font-size:14px;font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif">@HISAR-SERVICE / DSI</p>
                    </div>  
        </div>`,
            };
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/enviar-correo-adj/", data, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            window.location.reload();
                            this.dialogLoader = false;
                        });
                });
        },
        rechazarReunion(item, id) {
            this.eventId = id;
            this.newEvent.title = item.name_title;
            this.newEvent.description = item.details;
            this.newEvent.date = item.date;
            this.newEvent.startTime = item.hora_inicio_text;
            this.newEvent.endTime = item.hora_fin_text;
            this.newEvent.area = item.area;
            this.newEvent.participantes_id=item.participantes_id;
            this.newEvent.participantes = item.participantes;
            this.newEvent.color = item.color;
            this.newEvent.importancia = item.importancia;
            this.newEvent.sala = item.sala;
            
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de cancelar la reunión?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.dialogLoader = true;
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .post(RUTA_API + "/generar_eliminar_evento/", {
                                    id: this.eventId
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    /* Swal.fire({
                                        title: "¡Exito!",
                                        text: "La reunión se eliminó con exito.",
                                        icon: "success",
                                        draggable: true
                                    }); */
                                    /* console.log("personal corrreo", item.personal_correo);
                                    return; */
                                    this.loadEventos();
                                    this.notificarCorreoRechSol(this.newEvent,item.personal_correo);
                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });
                }
            });
        },
        seleccionarImportancia(item) {
            this.newEvent.importancia = item.tipo;
            this.$refs.selectEncImpor.isMenuActive = false; // Cierra el menú manualmente
        },
        seleccionarUsuario(item) {
            this.newEvent.color = item.codigo;
            this.$refs.selectEnc.isMenuActive = false; // Cierra el menú manualmente
        },
        closeEdit() {
            this.dialog = false;
            this.statusEdit = false;
            this.title = 'Nueva';
            this.titleButton = 'Enviar';
            this.clearForm();
        },
        deleteEvent(id) {
            this.eventId = id;
            Swal.fire({
                title: "¡Alerta!",
                text: "¿Esta seguro de eliminar la reunión?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Aceptar"
            }).then((result) => {
                // Este bloque se ejecutará cuando el usuario haga clic en el botón de confirmación
                if (result.isConfirmed) {
                    axios
                        .post(RUTA_API + "/api/token/", {
                            username: USUARIO,
                            password: PASSWORD,
                        })
                        .then((response) => {
                            this.auth = "Bearer " + response.data.access;
                            axios
                                .post(RUTA_API + "/generar_eliminar_evento/", {
                                    id: this.eventId
                                }, {
                                    headers: { Authorization: this.auth },
                                })
                                .then((res) => {
                                    Swal.fire({
                                        title: "¡Exito!",
                                        text: "La reunión se eliminó con exito.",
                                        icon: "success",
                                        draggable: true
                                    });
                                    this.loadEventos();
                                })
                                .catch((res) => {

                                });
                        })
                        .catch((response) => {
                            response === 404
                                ? console.warn("lo sientimos no tenemos servicios")
                                : console.warn("Error:", response);
                        });
                }
            });
        },
        updateEvent() {
            if (!this.newEvent.title || !this.newEvent.date || !this.newEvent.startTime || !this.newEvent.endTime || !this.newEvent.importancia || !this.newEvent.sala ) {
                Swal.fire({
                    title: "¡Error!",
                    text: "Por favor, completa los campos obligatorios",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                    customClass: {
                        popup: 'custom-swal-modal',
                        icon: 'mobile-error-icon'
                    }
                });
                return;
            }
            const newEvent = {
                name: this.newEvent.title,
                details: this.newEvent.description,
                date: this.newEvent.date,
                start: new Date(`${this.newEvent.date}T${this.newEvent.startTime}`),
                end: new Date(`${this.newEvent.date}T${this.newEvent.endTime}`), // 1 hora después por defecto
                startTime: this.newEvent.startTime,
                endTime: this.newEvent.endTime,
                area: this.newEvent.area_id,
                color: this.newEvent.color,
                participantes: this.newEvent.participantes,
                sala: this.newEvent.sala,
                importancia: this.newEvent.importancia,
                timed: true,
                correo_sol: this.newEvent.correo_sol,
                correo_jef: this.newEvent.correo_jef,
                participantes_id: this.newEvent.participantes_id,
                user_created:this.newEvent.user_created
            };
            this.dialogLoader = true;
            this.dialog = false;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_actualizar_evento/", {
                            id: this.eventId,
                            titulo: newEvent.name,
                            descripcion: newEvent.details,
                            fecha: newEvent.date,
                            hora_inicio: newEvent.start,
                            hora_fin: newEvent.end,
                            area: newEvent.area,
                            creado_por: 'AUDITORIA',
                            participantes: newEvent.participantes,
                            estado: '1',
                            color: '#039be5',
                            hora_inicio_text: `${newEvent.startTime}`,
                            hora_fin_text: `${newEvent.endTime}`,
                            sala: newEvent.sala,
                            importancia: newEvent.importancia,
                            correo_sol: newEvent.correo_sol,
                            correo_jef: newEvent.correo_jef,
                            user_created: newEvent.user_created,
                            participantes_id: newEvent.participantes_id
                        }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            Swal.fire({
                                title: "¡Exito!",
                                text: "La reunión se editó con exito.",
                                icon: "success",
                                draggable: true
                            });
                            this.eventId = null;
                            this.dialogLoader = false;
                            this.loadEventos();
                            /* window.location.reload(); */
                        })
                        .catch((res) => {
                            Swal.fire({
                                title: "¡Error!",
                                text: "Hubo un problema.",
                                icon: "error",
                                draggable: true
                            });
                            this.dialogLoader = false;
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
            this.dialog = false;
            this.statusEdit = false;
            this.clearForm();
        },
        openEdit(item, id) {
            this.eventId = id;
            this.statusEdit = true;
            this.title = 'Editar';
            this.titleButton = 'Actualizar';
            this.dialog = true;
            this.newEvent.title = item.name_title;
            this.newEvent.description = item.details;
            this.newEvent.date = item.date;
            this.newEvent.startTime = item.hora_inicio_text;
            this.newEvent.endTime = item.hora_fin_text;
            this.newEvent.area = null;
            this.newEvent.participantes_id = item.participantes_id;
            this.newEvent.color = item.color;
            this.newEvent.importancia = item.importancia;
            this.newEvent.sala = item.sala;
            this.newEvent.correo_sol = item.correo_sol;
            this.newEvent.user_created = item.user_created;
        },
        viewDay({ date }) {
            this.focus = date;
            this.type = 'day';
        },
        getEventColor(event) {
            return event.color;
        },
        setToday() {
            this.focus = '';
        },
        prev() {
            this.$refs.calendar.prev();
        },
        next() {
            this.$refs.calendar.next();
        },
        showEvent({ nativeEvent, event }) {
            this.selectedEvent = event;
            this.selectedElement = nativeEvent.target;
            requestAnimationFrame(() => (this.selectedOpen = true));
            nativeEvent.stopPropagation();
        },
        showEventClick(event, nativeEvent) {
            this.selectedEvent = event;
            this.selectedElement = nativeEvent.target;
            requestAnimationFrame(() => (this.selectedOpen = true));
            nativeEvent.stopPropagation();
        },
        saveEvent() {
            if (!this.newEvent.title || !this.newEvent.date || !this.newEvent.startTime || !this.newEvent.endTime || !this.newEvent.importancia) {
                Swal.fire({
                    title: "¡Error!",
                    text: "Por favor, completa los campos obligatorios",
                    icon: "error",
                    confirmButtonText: "Aceptar",
                    customClass: {
                        popup: 'custom-swal-modal',
                        icon: 'mobile-error-icon'
                    }
                });
                return;
            }
            const newEvent = {
                name: this.newEvent.title,
                details: this.newEvent.description,
                date: this.newEvent.date,
                start: new Date(`${this.newEvent.date}T${this.newEvent.startTime}`),
                end: new Date(`${this.newEvent.date}T${this.newEvent.endTime}`), // 1 hora después por defecto
                startTime: this.newEvent.startTime,
                endTime: this.newEvent.endTime,
                area: this.usuarioArea,
                color: '#039be5',
                participantes: this.newEvent.participantes,
                importancia: this.newEvent.importancia,
                sala: this.newEvent.sala,
                timed: true,
                correo_sol: this.newEvent.correo_sol,
                correo_jef: this.newEvent.correo_jef,
                participantes_id: this.newEvent.participantes_id
            };
            this.dialogLoader = true;
            this.dialog = false;
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_crear_evento/", {
                            titulo: newEvent.name,
                            descripcion: newEvent.details,
                            fecha: newEvent.date,
                            hora_inicio: newEvent.start,
                            hora_fin: newEvent.end,
                            area:this.usuarioArea,
                            area_id: newEvent.area,
                            creado_por: 'AUDITORIA',
                            participantes: newEvent.participantes,
                            estado: '1',
                            color: '#039be5',
                            hora_inicio_text: `${newEvent.startTime}`,
                            hora_fin_text: `${newEvent.endTime}`,
                            importancia: newEvent.importancia,
                            sala: newEvent.sala,
                            correo_sol: newEvent.correo_sol,
                            correo_jef: newEvent.correo_jef,
                            user_created:this.idUsuario ? parseInt(this.idUsuario, 10) || 0 : 0,
                            participantes_id: newEvent.participantes_id
                        }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.loadEventos();
                            this.dialogLoader = false;
                            Swal.fire({
                                title: "¡Exito!",
                                text: "Se registró la solicitud correctamente",
                                icon: "success",
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: "Aceptar"
                            });
                        })
                        .catch((res) => {
                            this.dialog = false;
                            this.dialogLoader = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
            this.dialog = false;
            // Limpiar formulario
            this.clearForm();
        },
        loadEventos() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_eventos/", {}, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.events = [];
                            this.events = res.data;
                        })
                        .catch((res) => {
                            this.dialog = false;
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        clearForm() {
            this.newEvent = {
                title: '',
                description: '',
                date: '',
                startTime: '',
                endTime: '',
                area: '',
                participantes: [],
                color: '#f6bf26',
                importancia: '',
                sala: '',
                correo_sol: '',
                correo_jef: '',
                participantes_id: [],
                user_created:null
            };
        }
    },
    components: {
        ChromePicker: Chrome
    },
};
</script>
<style scoped>
    ::v-deep .v-dialog {
        display: flex;
        justify-content: center;
        box-shadow: none;
        overflow-y: hidden !important;
    }

    .icon-ordinario {
        height: .7rem;
        width: .7rem;
        background: #04f785;
        border-radius: 100%;
    }

    .icon-importante {
        height: .7rem;
        width: .7rem;
        background: #ffee00;
        border-radius: 100%;
    }

    .icon-muy-importante {
        height: .7rem;
        width: .7rem;
        background: #ff0000;
        border-radius: 100%;
    }

    .hover-style {
        cursor: pointer;
    }

    .hover-style:hover {
        background-color: aliceblue;
    }

    .color-circle {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }

    .calendar-container {
        display: flex;
        font-family: Arial, sans-serif;
    }

    .sidebar {
        width: 20%;
        background: #f5f5f5;
        padding: 20px;
        box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
    }

    .sidebar ul {
        list-style: none;
        padding: 0;
    }

    .sidebar ul li {
        padding: 10px;
        cursor: pointer;
    }

    .sidebar ul li.active {
        background: #d0e8ff;
    }

    .sidebar-footer {
        margin-top: 20px;
        font-size: 14px;
    }

    .main-calendar {
        flex-grow: 1;
        padding: 20px;
    }

    .main-calendar header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .calendar-controls {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .calendar-controls button {
        border: none;
        background: #d0e8ff;
        padding: 5px 10px;
        cursor: pointer;
    }

    .calendar {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        gap: 5px;
    }

    .day-header {
        font-weight: bold;
        text-align: center;
    }

    .day-cell {
        border: 1px solid #ddd;
        padding: 10px;
        position: relative;
    }

    .day-cell.today {
        background: #f0f8ff;
    }

    .event {
        background: #d0e8ff;
        margin: 5px 0;
        padding: 5px;
        border-radius: 5px;
    }

    .event .time {
        font-size: 12px;
        font-weight: bold;
    }
</style>